import { render, staticRenderFns } from "./parcelDetails_kdy.vue?vue&type=template&id=33fbbb6b&scoped=true&"
import script from "./parcelDetails_kdy.vue?vue&type=script&lang=js&"
export * from "./parcelDetails_kdy.vue?vue&type=script&lang=js&"
import style0 from "./parcelDetails_kdy.vue?vue&type=style&index=0&id=33fbbb6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fbbb6b",
  null
  
)

export default component.exports